/* ============================================================
   FUZE BLOG — filtre catégorie + recherche + charger plus
   Opère sur les cartes rendues côté serveur par Liquid.
   Fonctionne en amélioration progressive :
   - JS actif  → filtrage/recherche instantanés + "charger plus"
   - JS coupé  → les chips restent des liens /tagged/... (Shopify filtre)
   ============================================================ */
(function () {
  var root = document.querySelector("[data-fz-blog]");
  if (!root) return;

  var grid    = root.querySelector("[data-fz-grid]");
  var chips   = Array.prototype.slice.call(root.querySelectorAll("[data-fz-chip]"));
  var search  = root.querySelector("[data-fz-search]");
  var moreWrap= root.querySelector("[data-fz-more]");
  var moreBtn = root.querySelector("[data-fz-more-btn]");
  var cards   = Array.prototype.slice.call(grid.querySelectorAll("[data-fz-card]"));

  // Ordre manuel : trie les cartes par data-order (métachamp grid_order), puis réinjecte dans le DOM
  cards.sort(function (a, b) {
    var oa = parseInt(a.getAttribute("data-order"), 10); if (isNaN(oa)) oa = 9999;
    var ob = parseInt(b.getAttribute("data-order"), 10); if (isNaN(ob)) ob = 9999;
    return oa - ob;
  });
  cards.forEach(function (c) { grid.appendChild(c); });

  var STEP  = parseInt(root.getAttribute("data-fz-step"), 10) || 9;
  var state = { q: "", tag: "all", shown: STEP };

  function matches(card) {
    var okTag = state.tag === "all" ||
      (" " + (card.getAttribute("data-tags") || "") + " ").indexOf(" " + state.tag + " ") > -1;
    var q = state.q.trim().toLowerCase();
    var okQ = !q || (card.getAttribute("data-search") || "").indexOf(q) > -1;
    return okTag && okQ;
  }

  function render() {
    var count = 0, shownCount = 0;
    cards.forEach(function (card) {
      if (matches(card)) {
        count++;
        if (shownCount < state.shown) { card.hidden = false; shownCount++; }
        else { card.hidden = true; }
      } else {
        card.hidden = true;
      }
    });

    var empty = grid.querySelector("[data-fz-empty]");
    if (empty) empty.hidden = count !== 0;
    if (moreWrap) moreWrap.hidden = state.shown >= count || count === 0;

    chips.forEach(function (c) {
      c.setAttribute("aria-pressed", c.getAttribute("data-fz-chip") === state.tag);
    });
  }

  chips.forEach(function (chip) {
    chip.addEventListener("click", function (e) {
      e.preventDefault();
      state.tag = chip.getAttribute("data-fz-chip");
      state.shown = STEP;
      render();
    });
  });

  if (search) {
    var t;
    search.addEventListener("input", function (e) {
      clearTimeout(t);
      t = setTimeout(function () {
        state.q = e.target.value;
        state.shown = STEP;
        render();
      }, 120);
    });
  }

  if (moreBtn) {
    moreBtn.addEventListener("click", function () {
      state.shown += STEP;
      render();
    });
  }

  render();
})();